import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import CategorySide from './categorySide/CategorySide';
import ProductSide from './productSide/ProductSide';
import { useState } from 'react';

function ProductManagement({ branchId: propBranchId }) {
  const user = useSelector(state => state.user.user);
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null); // null = 전체

  // props로 받은 branchId가 없으면 Redux에서 가져옴
  const branchId = propBranchId || user?.branch?.branchId;

  if (!branchId) {
    return (
      <Typography sx={{ pb: '30px', mt: '30px', fontSize: '20px', fontWeight: 500 }}>지점을 선택해주세요</Typography>
    );
  }

  return (
    <div style={{ display: 'flex', columnGap: '40px', paddingTop: '20px' }}>
      <CategorySide
        branchId={branchId}
        user={user}
        setCategories={setCategories}
        selectedCategoryId={selectedCategoryId}
        setSelectedCategoryId={setSelectedCategoryId}
      />
      <ProductSide
        branchId={branchId}
        user={user}
        categories={categories}
        selectedCategoryId={selectedCategoryId}
      />
    </div>
  );
}

export default ProductManagement;
